"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16CartFill = function Svg16CartFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.293 6c.23 0 .351 0 .439.007h.008l.003.008c.03.083.064.199.127.42l1.57 5.498-.762 1.78A2 2 0 0 0 8.517 16.5H16.5a1 1 0 1 0 0-2H8.517l.642-1.5h6.156c.32.002.721.003 1.085-.141a2 2 0 0 0 .806-.587c.25-.303.37-.686.467-.99l.027-.086.591-1.836c.104-.322.201-.624.259-.88.06-.271.11-.614.014-.981a2 2 0 0 0-.866-1.189c-.32-.203-.662-.262-.939-.287C16.498 6 16.181 6 15.843 6H7.826l-.033-.114-.025-.089c-.09-.318-.201-.717-.45-1.033a2 2 0 0 0-.816-.615c-.372-.153-.787-.15-1.117-.15L5.293 4H5a1 1 0 1 0 0 2h.293z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M10 18.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0zM15.25 20a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16CartFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16CartFill;
exports.default = _default;